var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.options.src)?_c('b-img',{staticClass:"cutin",attrs:{"src":_vm.options.src,"width":"800"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }